import { Box } from "@mui/material";

export default function CustomDivider() {
  return <Box sx={{ height: "1px", width: "100%", bgcolor: "#EDEDED" }}></Box>;
}
